<template>
    <div class="wrap">
        <div :class="['header_back']">
            <div class="back_icon" @click.stop="goback">
                <span></span>
            </div>
            {{$route.meta.title}}
        </div>
        <div class="back_content">
            <div class="content">
                <div class="title">系统隐蔽施工满意度评价</div>
                <div class="eva-content">
                    <template v-for="(item,index) in arrQuestion">
                        <div class="eva-item">
                            <div class="item-title">{{index+1}}.{{item.title}}</div>
                            <div class="score">
                                <div class="start">
                                    <template v-for="(it,itx) in 5">
                                        <img @click="scoreChage(item,itx)" v-if="itx>=item.score"  src="@/assets/images/processv2/d2vaa3x.png" alt="">
                                        <img @click="scoreChage(item,itx)" v-else src="@/assets/images/processv2/d2vaax.png" alt="">
                                    </template>
                                </div>
                                <div class="value">{{item.score}}分</div>
                            </div>
                            <div class="tag-wrap">
                                <template v-for="it in item.tags[item.score]">
                                    <div class="tag" v-if="it.check || isSubmit" :class="{'tag-active':it.check}"  @click="tagChage(it)">{{it.title}}</div>
                                </template>
                            </div>
                        </div>
                    </template>

                    <div class="eva-item">
                        <div class="item-title item-title-two">
                            <span :class="{'span':!isShowTextEva}" @click="isShowTextEva=true">文字评价</span>
                            <span v-if="sAudioUrl!='' && sAudioUrl!=null" :class="{'span':isShowTextEva}" @click="isShowTextEva=false">语音评价</span>
                        </div>
                        <div class="text-area" v-if="isShowTextEva && isSubmit">
                        <textarea
                            class="textarea no-resize"
                            :disabled="!isSubmit || isShowShare"
                            v-model.trim="evaText"
                            placeholder="您可以从购买体验、施工效果、服务质量等角度进行评价..."
                            maxlength="-1"
                        ></textarea>
                        </div>
                        <div class="text-area text-area-all" v-if="isShowTextEva && !isSubmit">
                            <div>{{evaText}}</div>
                        </div>
                        <div v-if="!isShowTextEva" class="text-voice-evaluate-content">
                            <!-- 点击试听录制语音 -->
                            <div @click="Audition" class="play-voice">
                                <div class="play-voice-fish"></div>
                                <span class="">{{ voice_time }}s</span>
                                <div class="play-voice-text">点击试听录制语音</div>
                                <audio
                                    ref="audioRef"
                                    class="audio-ref"
                                    :src="sAudioUrl"
                                />
                            </div>
                        </div>
                    </div>
                    <!--图片上传-->
                    <div class="image-uploading">
                        <div class="image-uploading-title" v-if="arrMedia">
                            <span> 图片/视频上传</span>
<!--                            <div class="photo-img" @click="openPhoto">-->
<!--                                <span>照片示例</span>-->
<!--                                <img src="@/assets/images/198.png" alt="">-->
<!--                            </div>-->
                        </div>
                        <div class="addContent2" style="margin-top: 0; padding: 0">
                            <div class="imgbox">
                                <div
                                    class="img-div"
                                    v-for="(item, index) in arrMedia"
                                    :key="index"
                                >
                                    <!-- 删除视频图片按钮 -->
                                    <img
                                        v-if="isSubmit"
                                        @click="deleImg(index)"
                                        class="delete-image"
                                        src="@/assets/images/image-delete.png"
                                    />
                                    <img
                                        v-if="item.type == 'image'"
                                        @click="handleImagePreview(arrMedia, index)"
                                        :src="item.url || item.pic"
                                        alt=""
                                        class="img"
                                    />
                                    <video
                                        v-else
                                        @click="playVideo(item.url || item.pic)"
                                        :src="item.url || item.pic"
                                        alt=""
                                        :poster="
                                        (item.url || item.pic) +
                                        '?x-oss-process=video/snapshot,t_1000,m_fast'
                                    "
                                        class="img"
                                    ></video>
                                    <div
                                        @click="playVideo(item.url || item.pic)"
                                        v-if="item.type != 'image'"
                                        class="video-play"
                                    ></div>
                                </div>
                                <!-- 上传图片视频按钮 -->
                                <div class="img-div" v-if="isSubmit">
                                    <img
                                        @click="choiceImg"
                                        src="@/assets/images/user/house/add_image_video.png"
                                        alt=""
                                        class="img"
                                    />
                                </div>
                                <input
                                    style="display: none"
                                    @change="imageToBase64"
                                    ref="filElem"
                                    type="file"
                                    id="input"
                                />
                                <div id="in-box" style="display: none"></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="popup" v-if="isSubmit && !isShowShare" @click="submit">
                <div class="oFail">提交</div>
            </div>
            <img @click="toHome" class="tohome-icon" src="@/assets/images/processv2/tohome.png" alt="">
        </div>
        <!-- 查看视频 -->
        <van-popup
            class="pop"
            v-model="isVideoShow"
            closeable
            position="bottom"
            :style="{ height: '100%' }"
            close-icon="close"
        >
            <div class="wrapper" v-if="isVideoShow">
                <video
                    playsinline="true"
                    webkit-playsinline="true"
                    :src="sVideoPath"
                    controls
                ></video>
            </div>
        </van-popup>
        <shematic v-if="isShowSchematic" @closeSchematic="closeSchematic"></shematic>
    </div>
</template>
<script>
import shematic from '../components/schematic'
import { tagList,discussAdd,evaInfo } from '@/js/house/appindex.js';
import net from "@/js/evaluate";
import OSS from "ali-oss";
import {ImagePreview} from "vant";
let matched = [];
export  default {
    components:{
        shematic
    },
    data(){
        return{
            isShowSchematic:false,
            isShowTextEva:true,//显示文本还是语音
            bBack: matched.length,
            isShowShare: false,//是否显示分享
            isSubmit:false,//是否是提交评价
            arrQuestion:[],//问题列表
            evaText:'',//文字评价
            objProject:{},
            voice_time: "", //录音秒数 如45s
            sAudioUrl: "", //语音评价value
            AuditionStatus: "试听录音", //控制试听的播放和暂停
            arrMedia: [], //本地展示的数据 图片 视频
            upLoadFiles: [], //传给后台的数据
            isVideoShow: false, //是否显显示视频播放控件
            sVideoPath: "", //弹出视频的src
        }
    },
    created() {
        this.objProject =JSON.parse(this.$storage.getStorage('objProjectEva'));
        this.getTagList()
    },
    methods:{
        openPhoto(){
            this.isShowSchematic=true
            document.body.style.overflow = 'hidden'
        },
        closeSchematic(){
            document.body.style.overflow = 'auto'
            this.isShowSchematic=false
        },
        uploadImg(inputFile) {
            this.$store.commit("loadSkeleton", { bool: true }); // 页面loading开启
            var data = inputFile.name;

            let flieArr = data.split(".");
            let suffix = flieArr[flieArr.length - 1];
            let uploadData = {
                ext: suffix,
                user_id: this.$storage.getStorage('app_user_id'),
                app:1
            };
            // 获取oss配置
            net.ossconfig(uploadData).then((res) => {
                let uploadOss = res.data.data.result;
                let client = new OSS({
                    region: uploadOss.sts.region,
                    bucket: uploadOss.sts.bucket,
                    accessKeyId: uploadOss.sts.access_key_id,
                    accessKeySecret: uploadOss.sts.access_key_secret,
                    endpoint: uploadOss.sts.endpoint_internal,
                    stsToken: uploadOss.sts.security_token,
                    secure: true,
                });

                // oss 上传
                client
                    .multipartUpload(uploadOss.object_name, inputFile)
                    .then((res) => {
                        this.upLoadFiles.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.filename,
                            default: uploadOss.default,
                        });
                        this.arrMedia.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.url,
                            default: uploadOss.default,
                        });
                        this.$store.commit("loadSkeleton", { bool: false }); // 页面loading关闭
                    });
            });
        },
        imageToBase64() {
            var _this = this;
            const inputFile = this.$refs.filElem.files[0];
            this.$refs.filElem.value = null;

            this.inputFile = inputFile;
            if (this.inputFile) {
                let inputFile = this.inputFile;
                // if (
                //     inputFile.type !== "image/jpeg" &&
                //     inputFile.type !== "image/png" &&
                //     inputFile.type !== "image/jpg" &&
                //     inputFile.type !== "video/mp4"
                // ) {
                //     alert("上传图片或者视频！", "warning");
                //     return;
                // }
                if (inputFile.size > 200 * 1024 * 1024) {
                    alert("请上传小于 200M 的图片 ！", "warning");
                    return;
                }
                this.uploadImg(inputFile);
            } else {
                alert(JSON.stringify(inputFile));
                return;
            }
        },
        choiceImg() {
            if (this.showInfo == 2) return;
            this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
        },
        playVideo(url) {
            this.isVideoShow = true;
            this.sVideoPath = url;
        },
        handleImagePreview(arrList, index) {
            console.log(arrList);
            // if (arrList[index].type === "image") {
            let arrImage = [];
            //let data = JSON.parse(JSON.stringify(arrList))
            arrList.forEach((item) => {
                //过滤video
                // if (item.type === "image") {
                if (item.pic) {
                    arrImage.push(item.pic);
                } else if (item.url) {
                    arrImage.push(item.url);
                }
                // }
            });
            let str = "";
            if (arrList[index].pic) {
                str = arrList[index].pic;
            } else if (arrList[index].url) {
                str = arrList[index].url;
            }
            console.log(arrImage);
            //arrImage.splice(index, 1)
            //arrImage.splice(0, 0, str)
            ImagePreview(arrImage, index);
            // }
        },
        // 删除图片
        deleImg(index) {
            this.arrMedia.splice(index, 1);
            this.upLoadFiles.splice(index, 1);
        },
        Audition() {
            const audio = this.$refs.audioRef;
            audio.paused ? audio.play() : audio.pause();
        },
        goback(){
            this.$router.go(-1);
        },
        toHome(){
            let objSam =JSON.parse(this.$storage.getStorage('sampleroom_info'));
            this.$router.push(`/member/v3/index/index?appmob=${this.$route.query.appmob}`)
        },
        // 获取评价详情
        getEvaInfo(id){
            this.$store.commit("loadSwitch", true);
            evaInfo({type:3,project_uuid:id,user_id: this.$storage.getStorage('app_user_id'),app:1, mobile: this.$route.query.appmob || ''}).then(res=>{
                this.$store.commit("loadSwitch", false);
                console.log(res,'评价999')
                if(JSON.stringify(res.data.data.result)!='[]'){
                    this.isSubmit=false
                    // 回显
                    this.evaText=res.data.data.result.content
                    let arrTag =JSON.parse(res.data.data.result.tags)
                    console.log(arrTag)
                    this.arrQuestion.forEach(item=>{
                        arrTag.forEach(it=>{
                            if(item.id==it.question_id){
                                item.score=it.score
                                item.tags[it.score].forEach(i=>{
                                    it.tags.forEach(ir=>{
                                        if(ir==i.id){
                                            i.check=true
                                        }
                                    })
                                })
                            }
                        })
                    })
                    this.sAudioUrl=res.data.data.result.voice || ''
                    this.voice_time=res.data.data.result.voice_time
                    // 图片视频
                    this.arrMedia=res.data.data.result.pic
                }else{
                    this.isSubmit=true
                }
            })
        },
        getTagList(){
            this.$store.commit("loadSwitch", true);
            tagList({type:'shigong',user_id: this.$storage.getStorage('app_user_id'),app:1,}).then(res=>{
                this.$store.commit("loadSwitch", false);
                this.arrQuestion=res.data.data.result.map(it=>{
                    for (const key in it.tags) {
                        for (const keyIt in it.tags[key]) {
                            it.tags[key][keyIt].check=false
                        }
                    }
                    it.score=0
                    return it
                })
                console.log(this.arrQuestion,'--')
                this.getEvaInfo( this.objProject.project_uuid || this.$route.query.project_uuid)
            })
        },
        // 评分
        scoreChage(item,value){
            if(!this.isSubmit){return}
            item.score=value+1
        },
        // 标签评价
        tagChage(it){
            if(!this.isSubmit){return}
            it.check=!it.check
        },
        submit(){
            // 判断是否全部评分
            let isScore = this.arrQuestion.find(it=>{
                return it.score==0
            })
            if(isScore || !this.evaText){
                this.$toast('请完善评分!')
                return
            }
            if(!this.evaText){
                this.$toast("请输入评价文字!");
                return;
            }
            if(this.upLoadFiles.length<=0){
                this.$toast("至少上传一张图片!");
                return;
            }
            let tagSub = []
            this.arrQuestion.forEach(it=>{
                let obj = {}
                let tags =[]
                obj.question_id=it.id
                obj.score=it.score
                it.tags[it.score].forEach(i=>{
                    if(i.check){
                        tags.push(i.id)
                    }
                })
                obj.tags=tags
                tagSub.push(obj)
            })
            // 判断是否选择了标签
            let filtertagSub=[]
            filtertagSub = tagSub.filter(it=>{
                return it.tags.length<=0
            })
            if(filtertagSub.length>0){
                this.$toast("评价标签有未选项");
                return;
            }
            let data = {}
            data.pic=JSON.stringify(this.upLoadFiles)//oss返回的图片或视频链接
            data.type=3
            data.content=this.evaText
            data.is_anonymous=1
            data.tags=JSON.stringify(tagSub)
            data.contract_id=this.objProject.contract_id
            data.project_uuid=this.objProject.project_uuid || this.$route.query.project_uuid
            data.topic_id=this.objProject.topic_id
            data.share_user_id = this.$route.query.sharePersonId || 0
            data.is_app=1
            data.user_id = this.$storage.getStorage('app_user_id')
            this.$store.commit("loadSwitch", true);
            discussAdd(data).then(res=>{
                this.$toast('评价成功')
                setTimeout(()=>{
                    this.$store.commit("loadSwitch", false);
                },500)
                this.$router.go(0);
                // setTimeout(()=>{
                //     this.$router.go(-1);
                // },800)
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.tohome-icon{
    position: fixed;
    bottom: 200px;
    right: 50px;
    width: 100px;
    height: 100px;
    z-index: 99;
}
.wrap{
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
    padding-bottom: env(safe-area-inset-bottom);
    .back_content{
        justify-content: center;
        padding: 16px;
        background: #F9F9F9;
        width: 100vw;
        height: calc(100vh - env(safe-area-inset-bottom) - 180px);
        overflow: hidden;
    }
    .header_back{
        background: #FFF;
        padding-top: 60px;
        box-sizing: border-box;
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        position: relative;
        .back_icon{
            position: absolute;
            left: 50px;
            width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            span{
                display: block;
                width: 18px;
                height: 18px;
                border: 3px solid #000;
                border-right: 0;
                border-bottom: 0;
                transform: rotate(-45deg);
            }
        }
    }
    .popup{
        position: fixed;
        bottom: 0;
        z-index: 99;
        left: 0;
        width: 100%;
        height: 180px;
        background: #FFFFFF;
        box-shadow: 0px 8px 32px 0px rgba(0,0,0,0.08);
        border-radius: 24px 24px 0px 0px;
        backdrop-filter: blur(0px);
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: env(safe-area-inset-bottom);
        .oFail{
            width: 686px;
            height: 72px;
            background: #355D4B;
            border-radius: 36px;
            font-size: 24px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 72px;
            text-align: center;
        }
    }
    .content{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        border-radius: 24px 24px 0px 0px;
        backdrop-filter: blur(0px);
        padding: 48px 48px 180px 48px;
        overflow-y: scroll;
        .title{
            font-size: 36px;
            font-weight: 500;
            color: #333333;
        }
        .eva-content{
            .eva-item{
                margin-top: 64px;
                .text-area{
                    margin-top: 32px;
                    width: 100%;
                    height: 224px;
                    border-radius: 16px;
                    border: 1px solid #DDDDDD;
                    textarea{
                        width: 100%;
                        height: 100%;
                        padding: 14px 32px;
                        font-size: 26px;
                    }
                }
                .text-area-all{
                    font-size: 28px;
                    line-height: 36px;
                    letter-spacing: 1px;
                    padding: 14px 32px;
                    height: auto;
                }
                .item-title{
                    font-size: 28px;
                    font-weight: 500;
                    color: #333333;
                }
                .item-title-two{
                    span{
                        margin-right: 20px;
                    }
                    .span{
                        color: #d6d6d6;
                    }
                }
                .score{
                    margin-top: 30px;
                    display: flex;
                    align-items: center;
                    .start{
                        display: flex;
                        align-items: center;
                        img{
                            width: 36px;
                            margin-right: 8px;
                            height: 36px;
                        }
                    }
                    .value{
                        font-size: 24px;
                        font-weight: 800;
                        color: #FCBF82;
                        margin-left: 32px;
                        margin-top: 5px;
                    }
                }
                .tag-wrap{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin-top: 32px;
                    .tag{
                        margin-right: 16px;
                        margin-bottom: 16px;
                        font-size: 24px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 64px;
                        padding: 0 24px;
                        height: 64px;
                        border-radius: 16px;
                        border: 1px solid #DDDDDD;
                    }
                    .tag-active{
                        background: rgba(53, 93, 75, 0.1);
                        font-weight: bold;
                        color: #355D4B;
                        border: 1px solid transparent;
                    }
                }
            }
        }
    }
}
.addContent2 {
    width: 100%;
    margin-top: 60px;
    padding: 0 32px;
    div:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #444444;
        line-height: 40px;
        margin-bottom: 24px;
    }
    .input {
        width: 100% !important;
        padding: 24px;
        background: #f7f7f7;
        border-radius: 12px;
        width: 232px;
        font-size: 28px;
        font-weight: 400;
        color: #858585;
        line-height: 40px;
        margin-bottom: 28px;
    }
    .imgbox {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 40px;

        .img {
            width: 160px;
            height: 160px;
            background: #eeeeee;
            border-radius: 24px;
            // margin: 10px;
            object-fit: cover;
        }

        .img-div {
            width: 160px;
            height: 160px;
            position: relative;
            margin: 0 32px 32px 0;
        }
    }
    .addContentBtn {
        width: 186px;
        height: 68px;
        margin: 0 auto;
        // padding: 16px 44px;
        text-align: center;
        line-height: 69px;
        border-radius: 43px;
        border: 2px solid #898989;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #444444;
        margin-bottom: 74px;
    }
}
.delete-image {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 70;
}
.video-play {
    position: absolute;
    top: 0;
    left: 0;
    width: 160px;
    height: 160px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 24px;
    z-index: 10;
    &::before {
        content: "";
        position: absolute;
        top: 65px;
        left: 65px;
        border-top: 20px solid transparent;
        border-left: 40px solid #fff;
        border-bottom: 20px solid transparent;
        z-index: 11;
    }
}
.pop {
    background-color: transparent;
}
.image-uploading {
    width: 654px;
    height: auto;
    margin: 40px auto 0 auto;
    .image-uploading-title {
        width: 100%;
        height: 32px;
        font-size: 28px;
        color: #333333;
        line-height: 28px;
        margin-bottom: 32px;
        font-weight: 500;
        margin-left: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 50px;
        .photo-img{
            font-size: 28px;
            color: #83A594;
            display: flex;
            align-items: center;
            img{
                margin-left: 6px;
                width: 8px;
                height: 14px;
            }
        }
    }
}
.text-voice-evaluate-content {
    width: 654px;
    height: 224px;
    border-radius: 16px;
    border: 1px solid #dddddd;
    margin: 0 auto;
    margin-top: 32px;
    padding: 40px 32px;
    .text {
        width: 100%;
        height: 100%;
        font-size: 28px;
        line-height: 44px;
        overflow: scroll;
        &::-webkit-input-placeholder {
            color: #dddddd;
        }
    }
    .recording-voice {
        width: 160px;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        .recording-voice-btn {
            width: 112px;
            height: 112px;
            background: #f5f7f6;
            border-radius: 100%;
            margin-bottom: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: url("../../../../assets/images/user/house/yuyin-da.png")
            no-repeat;
            background-size: 112px 112px;
        }
        span {
            color: #999999;
            font-size: 20px;
        }
    }
    .play-voice {
        position: relative;
        width: 100%;
        margin-top: 40px;
        height: 88px;
        background: #f5f7f6;
        border-radius: 44px;
        display: flex;
        align-items: center;
        padding: 0 48px 0 24px;
        color: #355d4b;
        font-size: 24px;
        .play-voice-fish {
            width: 48px;
            height: 48px;
            background: url("../../../../assets/images/user/house/yuyin-play.png")
            no-repeat;
            background-size: 48px 48px;
            margin-right: 8px;
        }
        .voice-icon {
            width: 18px;
            height: 24px;
            background: url("../../../../assets/images/user/house/yuyin-xiao.png")
            no-repeat;
            background-size: 18px 24px;
        }
        .delete {
            margin-left: auto;
        }
        .wire {
            margin: 0 24px 0 22px;
        }
        .play-voice-text {
            position: absolute;
            bottom: -48px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 20px;
            color: #999999;
        }
    }
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    video {
        width: 100%;
    }
}
</style>
